import { render, staticRenderFns } from "./ServicePanel.vue?vue&type=template&id=40518828&scoped=true"
import script from "./ServicePanel.vue?vue&type=script&lang=js"
export * from "./ServicePanel.vue?vue&type=script&lang=js"
import style0 from "./ServicePanel.vue?vue&type=style&index=0&id=40518828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40518828",
  null
  
)

export default component.exports